<template>
  <v-card class="ma-1">
    <v-card-title>
      <div class="mr-auto">
        Importer varer fra Excel eller CSV
      </div>

      <div v-if="matching" class="mx-4">
        <v-progress-linear indeterminate></v-progress-linear>
        Søger efter matchende varer
      </div>
  
      <v-btn
        :disabled="!importText"
        @click="importParts"
        :loading="matching"
      >
        Søg
        <v-icon right>mdi-magnify</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-subtitle>
      Du kan også indsætte linjer med varenummer og et antal
    </v-card-subtitle>
    <v-card-text>
      <v-textarea
        v-model="importText"
        outlined
        :error-messages="importErrors"
      />
    </v-card-text>
  </v-card>
</template>

<script>
import { Line } from '@/helpers/classes';
import { stringify } from 'qs';

export default {
  name: 'PartBulkCSVImport',
  emits: ['import'],
  props: {
    matchPart: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      importText: '',
      importErrors: [],
      matching: false
    }
  },
  methods: {
    importParts: async function() {
      const rawLines = this.importText.split('\n');
      const lines = [];
      let errors = 0;
      this.importText = '';
      
      // Clean empty lines
      const linesFiltered = rawLines.filter(line => line !== '');

      linesFiltered.forEach(line => {
        if (line.includes('\t')) {
          const [ partNumber, quantity ] = line.split('\t');
          lines.push(new Line(partNumber, quantity));
        } else {
          const newLine = new Line(line, 1);
          lines.push(newLine);
        }
      });

      if (this.matchPart) {
        this.matching = true;

        const query = {
          customerId: this.$store.state.primaryCustomerId,
          partNumbers: lines.map(line => line.partNumber),
          isValid: true
        };

        try {
          const { data } = await this.$api.get('part-customers', {
            params: query,
            paramsSerializer: function (params) {
              return stringify(params, { indices: null })
            }
          });

          const matchedPartCustomers = data;

          lines.forEach(line => {
            const part = matchedPartCustomers.find(x => x.partNumber === line.partNumber);

            if (!part) {
              line.errors.push(`${line.partNumber}: Ingen varer fundet for kunden`);
            } else {
              line.part = part;
            }
          });
        } catch(error) {
          console.error(error);
        } finally {
          this.matching = false;
        }
      }

      if (errors) {
        this.importErrors = `${errors} linje(r) kunne ikke importeres`;
      }

      if (lines.length) {
        this.$emit('import', lines)
      }
    }
  }
}
</script>